var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nv-app',{attrs:{"navigation":_vm.navigation,"user":{ can: _vm.$auth.hasPermissions },"title":"Global Digital Reference System","icon":"/images/owl.svg"},scopedSlots:_vm._u([{key:"confirm",fn:function(){return [_c('nv-confirm',{ref:"confirm"})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }